import _ from 'underscore';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withPopover } from '@bingads-webui/filter-commons';
import { getViewAllFiltersButtonStyle } from './style';

const FilterListImpl = ({
  filters, onClickFilter, i18n, classes,
}) => (
  <Fragment>
    {_.map(filters, filter =>
    (
      <Button
        key={`filter-${filter.id}`}
        btnStyle="link"
        className={classNames(classes.viewAllFilterItem, 'view-all')}
        onClick={() => onClickFilter(filter)}
      >
        <span>{`${i18n.getString(filter.title)}: ${filter.humanizedValue}`}</span>
      </Button>
    ))}
  </Fragment>
);

FilterListImpl.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    humanizedValue: PropTypes.string,
  })).isRequired,
  onClickFilter: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    viewAllFilterItem: PropTypes.string,
  }).isRequired,
};

export const FilterList = withDefaultStyles(FilterListImpl, getViewAllFiltersButtonStyle);

const FilterListWithPopover = withPopover(FilterList);

const ViewAllFiltersButtonImpl = ({
  filters, onClickFilter, i18n, classes,
}) => {
  // don't show the always visible filters on the View all popover
  const selectedFilters = _.filter(filters, ({ isFilterAlwaysVisible }) => !isFilterAlwaysVisible);
  return (_.isEmpty(selectedFilters) ? null : (
    <FilterListWithPopover
      closeButton
      placement="right"
      title={i18n.getString(_TL_('Filters'))}
      filters={selectedFilters}
      onClickFilter={onClickFilter}
      popoverClassName={classes.viewAllPopoverClassName}
      classes={{
      calloutCloseButton: classes.viewAllPopoverCloseButton,
    }}
      i18n={i18n}
    >
      <Button btnStyle="link">{i18n.getString(_TL_('View all'))}</Button>
    </FilterListWithPopover>
  ));
};

ViewAllFiltersButtonImpl.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    isFilterAlwaysVisible: PropTypes.bool,
  })).isRequired,
  onClickFilter: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    viewAllPopoverClassName: PropTypes.string,
    viewAllPopoverCloseButton: PropTypes.string,
  }).isRequired,
};

export const ViewAllFiltersButton = React.memo(withDefaultStyles(ViewAllFiltersButtonImpl, getViewAllFiltersButtonStyle));
